import { CSSProperties } from 'react';

import logoAbracrim from '../../assets/images/abracrim/abracrim_logo.png';

import { LogoType } from '.';

interface LogoAbracrimProps {
  type: LogoType;
}

const styles = {
  logOn: {
    width: '8rem',
    alignSelf: 'center',
    marginLeft: '1rem',
    objectFit: 'contain',
    height: '3rem',
    marginTop: '.5rem',
  } as CSSProperties,

  logOff: {
    width: '8rem',
  },
};

export default function LogoAbracrim({ type }: LogoAbracrimProps) {
  return <img style={styles[type]} src={logoAbracrim} alt="Logo do Abracrim" />;
}